import { useMemo } from 'react';
import { convertToUUID } from 'uuid-encoding';

import {
  ProductType,
  SortDirection,
  ProductsFilter,
} from 'graphql-query-contracts';
import { listProductsQuery } from 'graphql-queries';
import { getClient } from 'lane-shared/apollo';

const DEFAULT_BULK_PAGE_SIZE = 10000;

type Filters = {
  name?: string;
  chargeCodes?: string[];
};

type SortBy = {
  id?: string;
  direction?: SortDirection;
};

export function useProductsListForExport() {
  async function getProductsForExport(
    channelId: string,
    parentChannelId: string | undefined,
    product: { types: ProductType[]; categoryId: string },
    {
      sort,
      filters,
    }: {
      sort: SortBy;
      filters?: Filters;
    }
  ) {
    const groupIds = [convertToUUID(channelId)];

    if (parentChannelId) {
      groupIds.push(convertToUUID(parentChannelId));
    }

    let queryFilters: ProductsFilter = {
      groupIds,
      productTypes: product?.types || [],
      productCategoryId: product?.categoryId || '',
    };

    if (filters?.name) {
      queryFilters = {
        ...queryFilters,
        productName: filters.name,
        productCategoryName: filters.name,
      };
    }

    if (filters?.chargeCodes) {
      queryFilters = {
        ...queryFilters,
        chargeCodes: filters.chargeCodes,
      };
    }

    try {
      const { data } = await getClient().query({
        query: listProductsQuery,
        variables: {
          filter: queryFilters,
          pagination: {
            start: 0,
            perPage: DEFAULT_BULK_PAGE_SIZE,
          },
          sortBy: {
            key: sort.id,
            dir: sort.direction,
          },
        },
        fetchPolicy: 'network-only',
      });

      return data?.listProducts?.products;
    } catch {
      return [];
    }
  }

  return useMemo(() => ({ getProductsForExport }), [getProductsForExport]);
}
